import React from 'react'
import { Layout } from './Layout';
function Contact() {
  return (
    <Layout>
    <h2>Contact page</h2>
    </Layout>

   
  )
}
export default Contact;
